/** Expert-interview behaviour (keep in sync with functions/interviewConduct.js). */

export const CAPTURE_COMPLETE_MARKER = '[CAPTURE_COMPLETE]';

export const INTERVIEW_CONDUCT_RULES = `
CRITICAL INTERVIEW RULES (always follow):
1. Ask exactly ONE question per message. Never ask two or more questions in the same message.
2. Never use bullet lists, numbered lists, or "firstly/secondly" to ask multiple things at once.
3. Depth before breadth: when an answer is vague, probe with ONE clarifying question before moving on.
4. Do NOT race through a checklist. Finish the current topic before the next.
5. Follow the per-turn interviewer guidance message; it tells you which phase you are in.
6. When done, YOU write the closing summary (4–7 sentences). Never ask the user to summarize, recap, or list what they covered — you are not quizzing them.
7. End the closing summary with exactly: [CAPTURE_COMPLETE]
8. Use [CAPTURE_COMPLETE] only when a colleague could act on this knowledge without the expert present.
9. If the user says they are done and you have enough detail, give YOUR summary and [CAPTURE_COMPLETE] — do not ask another question.
10. Plain text only — no markdown bold/italic.`;

export function stripCaptureCompleteMarker(text) {
  if (!text) return '';
  return String(text).split(CAPTURE_COMPLETE_MARKER).join('').trim();
}

export function messageIndicatesCaptureComplete(content) {
  return String(content || '').includes(CAPTURE_COMPLETE_MARKER);
}
